module.exports = __webpack_public_path__ + "static/media/builtinv2-Setevoe wap.ce16448a.png";